function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-32.3%",
  y: "-32.3%",
  width: "164.5%",
  height: "164.5%",
  filterUnits: "objectBoundingBox",
  id: "messages_broadcast_image_svg__a"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("path", {
  d: "M60 127c27.852 0 51.272-18.978 58.034-44.707C119.317 77.41 154 65.833 154 60.547c0-13.168-27.576-43.152-34.769-53.047C108.325-7.504 79.97 7 60 7 26.863 7 0 33.863 0 67s26.863 60 60 60z",
  id: "messages_broadcast_image_svg__b"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#D84C79",
  filter: "url(#messages_broadcast_image_svg__a)",
  cx: 83.5,
  cy: 94.5,
  r: 46.5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24 14)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  y: 7,
  width: 120,
  height: 120,
  rx: 60
}), /*#__PURE__*/React.createElement("mask", {
  id: "messages_broadcast_image_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#messages_broadcast_image_svg__b"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#messages_broadcast_image_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.304 116.79l-9.303-1.906-5.384 5.575-18.35-14.484 12.238-8.352 13.013-14.24c2.181-2.388 6.037-2.043 7.76.693l15.417 17.682c2.33 2.672 1.67 6.803-1.376 8.618l-9.083 5.409c-1.586.958-3.095 1.04-4.932 1.006",
  fill: "#FFF5EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.695 101.758l-3.762-4.315-15.688 9.35c-1.586.958-3.096 1.04-4.933 1.005l-8.148-.877-7.039 6.046 9.493 7.492 5.383-5.576 9.303 1.908c1.837.033 3.347-.048 4.932-1.006l9.083-5.41c3.047-1.814 3.706-5.945 1.376-8.617",
  fill: "#F4E2CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.242 102.135c-1.817-2.817-4.03-1.392-5.846-4.21-1.816-2.817.397-4.243-1.42-7.06-1.817-2.818-4.029-1.392-5.845-4.21-1.818-2.819.395-4.245-1.422-7.063-1.11-1.722-3.122-5.278-4.347-5.767l-9.805 4.844 17.062 26.91a5.563 5.563 0 007.69 1.66l3.265-2.103c.997-.643 1.322-1.977.682-2.977a.283.283 0 00-.014-.024",
  fill: "#344A5D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.04 82.835l-7.703 4.752a3.11 3.11 0 01-4.28-1.013l-4.354-7.057a3.11 3.11 0 011.014-4.28l7.702-4.752a1.925 1.925 0 012.649.627l5.598 9.074c.559.905.278 2.09-.627 2.649",
  fill: "#344A5D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.765 57.624L46.132 67.27a4.377 4.377 0 00-1.428 6.023l7.71 12.495a4.377 4.377 0 006.024 1.427l15.634-9.646 49.448-10.764-29.955-48.549-31.8 39.367z",
  fill: "#F9BA48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.462 55.367L67.268 66.545 47.91 78.49l4.505 7.3a4.376 4.376 0 006.023 1.426l15.635-9.647 49.448-10.763-7.058-11.439z",
  fill: "#F99848"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.072 77.57l-15.635 9.645a4.376 4.376 0 01-6.023-1.426l-7.71-12.495a4.376 4.376 0 011.427-6.023l15.634-9.647L74.072 77.57z",
  fill: "#FD715C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.268 66.545L47.91 78.49l4.505 7.299a4.376 4.376 0 006.023 1.426l7.817-4.823 7.817-4.822-6.803-11.025z",
  fill: "#D83E3A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.486 70.255l-2.134 1.317a2.354 2.354 0 01-3.238-.767l-32.203-52.19a2.353 2.353 0 01.767-3.24l2.135-1.316a2.352 2.352 0 013.238.767l32.203 52.19a2.354 2.354 0 01-.768 3.24",
  fill: "#FD715C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.254 67.016l-5.298-8.587-6.14 3.79 5.298 8.586a2.353 2.353 0 003.238.767l2.134-1.317a2.354 2.354 0 00.768-3.239",
  fill: "#D83E3A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.39 109.24a4.042 4.042 0 005.557 1.343l5.891-3.602a4.042 4.042 0 00-4.215-6.896l-5.892 3.6a4.042 4.042 0 00-1.341 5.555",
  fill: "#FFF5EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.18 101.426a4.016 4.016 0 00-1.969-1.648 4.042 4.042 0 01-1.896 3.99l-5.892 3.6a4.033 4.033 0 01-3.587.309 4.042 4.042 0 006.111 2.906l5.891-3.602a4.041 4.041 0 001.342-5.555",
  fill: "#F4E2CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.866 101.287a4.102 4.102 0 005.64 1.362l5.788-3.537a4.103 4.103 0 00-4.278-7l-5.788 3.537a4.101 4.101 0 00-1.362 5.638",
  fill: "#FFF5EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.656 93.473a4.083 4.083 0 00-1.93-1.647 4.099 4.099 0 01-1.928 4.017l-5.788 3.538a4.094 4.094 0 01-3.71.286 4.102 4.102 0 006.207 2.983l5.787-3.538a4.103 4.103 0 001.362-5.639",
  fill: "#F4E2CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.552 94.332a4.103 4.103 0 005.64 1.362l5.789-3.538a4.102 4.102 0 00-4.28-7l-5.787 3.537a4.102 4.102 0 00-1.362 5.639",
  fill: "#FFF5EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.342 86.518a4.081 4.081 0 00-1.882-1.629 4.1 4.1 0 01-1.934 3.957l-5.788 3.538a4.095 4.095 0 01-3.758.266c.064.578.248 1.152.572 1.681a4.103 4.103 0 005.641 1.362l5.788-3.537a4.102 4.102 0 001.361-5.638",
  fill: "#F4E2CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.486 87.198a4.102 4.102 0 005.64 1.362l5.788-3.538a4.102 4.102 0 10-4.279-7l-5.788 3.537a4.103 4.103 0 00-1.361 5.64",
  fill: "#FFF5EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.276 79.383a4.078 4.078 0 00-2.298-1.779 4.1 4.1 0 01-1.868 4.356l-5.788 3.538a4.086 4.086 0 01-3.343.417 4.1 4.1 0 00.507 1.283 4.102 4.102 0 005.64 1.361l5.788-3.537a4.102 4.102 0 001.362-5.639",
  fill: "#F4E2CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.169 92.161l-1.073.656c-1.69 1.032-3.872.537-4.878-1.105l-1.778-2.908c-.87-1.423-2.764-1.846-4.22-.942-1.463 10.732-16.715 9.761-16.715 9.761l9.451-14.234a7.6 7.6 0 012.575-2.652l5.334-3.307c2.592-1.608 5.963-.858 7.515 1.675l5.027 8.204c1.007 1.645.453 3.819-1.238 4.852",
  fill: "#FFF5EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.406 87.31l-.04-.068a3.645 3.645 0 01-1.197 1.187l-1.074.657c-1.689 1.032-3.871.537-4.877-1.106l-1.777-2.907c-.871-1.423-2.765-1.846-4.222-.943-.613 4.501-3.365 8.814-6.437 11.769 3.107-1.366 5.857-3.78 6.437-8.037 1.457-.904 3.35-.48 4.222.942l1.777 2.908c1.006 1.642 3.188 2.137 4.877 1.106l1.074-.657c1.69-1.033 2.245-3.207 1.237-4.851",
  fill: "#F4E2CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.913 120.81L40.88 102.946l4.95-4.165a.37.37 0 01.521.044l14.557 17.3a.37.37 0 01-.045.52l-4.95 4.165z",
  fill: "#CDD6DF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.907 116.124l-7.743-9.203-5.233 4.404 7.982 9.486 4.95-4.166a.37.37 0 00.044-.52",
  fill: "#96A4AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.93 37.03a1.783 1.783 0 01-.937-3.305l9.67-5.948a1.783 1.783 0 011.87 3.039l-9.67 5.948c-.292.18-.615.265-.933.265M140.218 51.592c-.057 0-.116-.002-.174-.008l-14.177-1.378a1.784 1.784 0 11.345-3.55l14.177 1.377a1.784 1.784 0 01-.17 3.56M109.816 23.843a1.783 1.783 0 01-1.662-2.431l5.163-13.275a1.785 1.785 0 013.326 1.294l-5.164 13.274a1.786 1.786 0 01-1.663 1.138",
  fill: "#DBD9D1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.986 120.643l-16.248-19.06a.391.391 0 00-.518-.069l-17.304 13.66a2.408 2.408 0 00-.916 1.89v5.557a2.407 2.407 0 002.408 2.407h28.307c.729 0 1.42-.33 1.877-.9l2.378-2.96a.392.392 0 00.016-.525",
  fill: "#3C5666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.282 111.605l-11.343 13.423L50.937 127c.73 0 1.42-.33 1.877-.9l4.156-4.931a.392.392 0 00.016-.526l-7.704-9.038z",
  fill: "#194451"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M155.486 93c.65 0 1.176.526 1.176 1.176v3.134h3.135c.606 0 1.105.46 1.17 1.048l.006.128c0 .65-.526 1.176-1.176 1.176h-3.135v3.135c0 .606-.458 1.105-1.047 1.17l-.129.006c-.649 0-1.175-.526-1.175-1.176l-.001-3.135h-3.134a1.176 1.176 0 01-1.17-1.047l-.006-.129c0-.649.526-1.175 1.176-1.175l3.134-.001v-3.134c0-.606.46-1.105 1.048-1.17z",
  fill: "#F9BA48",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.486 0c.886 0 1.605.718 1.605 1.604l-.001 4.278h4.279c.837 0 1.524.64 1.597 1.458l.007.146c0 .886-.718 1.605-1.604 1.605L71.09 9.09v4.279c0 .837-.64 1.524-1.457 1.597l-.147.007a1.604 1.604 0 01-1.604-1.604V9.09h-4.278c-.837 0-1.524-.64-1.597-1.457L62 7.486c0-.886.718-1.604 1.604-1.604h4.278V1.604c0-.837.64-1.524 1.458-1.597z",
  fill: "#44C94E",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#DA4D7A",
  cx: 2.5,
  cy: 54.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#913FA3",
  cx: 135.5,
  cy: 137.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#0086D8",
  strokeWidth: 2,
  cx: 8.5,
  cy: 131.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#E57339",
  strokeWidth: 2,
  cx: 146.5,
  cy: 21.5,
  r: 3.5
}));

function SvgMessagesBroadcastImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 171,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/messages_broadcast_image.974a10b6.svg";
export { SvgMessagesBroadcastImage as ReactComponent };